module.exports = __webpack_public_path__ + "assets/img/parents-image.b43e6472.jpg";